'use client'

import dynamic from 'next/dynamic'
import type { ReactNode } from 'react'

// Dynamic import to avoid SSR — ThemeProvider reads document.documentElement
const ThemeProvider = dynamic(
  () => import('../../phishtrainer/play/_player/contexts/ThemeContext').then((m) => m.ThemeProvider),
  { ssr: false },
)

export function PlayerThemeProvider({ children }: { children: ReactNode }) {
  return <ThemeProvider>{children}</ThemeProvider>
}
